// extracted by mini-css-extract-plugin
module.exports = {"main":"Card_main__37tka","box":"Card_box__1jc0X","imgBx":"Card_imgBx__273Pj","content":"Card_content__3Ie1M"};